export default __webpack_public_path__ + "media/images/fancybox/fancy_shadow_nw-7c2a0586e3c97592cb8c3b953f731be0.png";